// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import API_URL from "../Config";
// import Swal from "sweetalert2";
// import logo from "../assets/img/mjlogo.png";
// import { Mail, User, Lock, Phone, MapPin, Building } from "lucide-react";

// const AdminSignin = () => {
//   const navigate = useNavigate();
//   const [data, setData] = useState({
//     username: "",
//     mobnum: "",
//     address: "",
//     email: "",
//     compname: "",
//     country: "",
//     password: "",
//     confirm_Password: "",
//     code: "",
//   });

//   const handleChange = (e) => {
//     setData({ ...data, [e.target.name]: e.target.value });
//   };

//   const submitForm = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(`${API_URL}/api/v2/AdminRegister`, data);
//       if (response.status === 200) {
//         Swal.fire("Success", "Registration successful!", "success");
//         navigate("/admin");
//       }
//     } catch (error) {
//       Swal.fire("Error", "Something went wrong!", "error");
//     }
//   };

//   return (
//      <div className="w-screen h-screen flex items-center justify-center bg-gradient-to-b from-black to-blue-950 px-4">
//   <div className="flex rounded-2xl overflow-hidden w-full max-w-6xl">

//     <div className="w-1/3 flex items-center justify-center bg-transparent">
//       <img src={logo} alt="Media Jungle" className="w-80 scale-110 drop-shadow-lg" />
//     </div>
    
//     {/* Left: Form Section */}
//     <div className="w-2/3 flex flex-col justify-center px-10 py-12">
      
//       {/* Title */}
//       <div className="text-center mb-8">
//         <h1 className="text-7xl font-bold text-white">Welcome</h1>
//         <p className="text-2xl text-gray-300">
//           To New <span className="font-bold text-white">Admin</span>
//         </p>
//       </div>

//       {/* Form */}
//       {/* <form onSubmit={submitForm} className="grid grid-cols-2 gap-4 w-full"> */}
//       <form onSubmit={submitForm} className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
//         {/* Username */}
//         <div className="flex items-center bg-white rounded-xl px-4 py-3 h-14 w-full">
//           <User className="text-gray-500 mr-2" size={18} />
//           <input
//             type="text"
//             name="username"
//             placeholder="Username"
//             value={data.username}
//             onChange={handleChange}
//             className="w-full bg-transparent outline-none text-gray-800"
//           />
//         </div>
// <div className="flex bg-white rounded-xl px-3 py-2 items-center space-x-2 h-14 w-full">
//   <Mail className="text-gray-500" size={18} />
//   <input
//     type="email"
//     name="email"
//     placeholder="Email"
//     value={data.email}
//     onChange={handleChange}
//     className="flex-grow bg-transparent outline-none text-gray-800 min-w-0"
//   />
//   <button
//     type="button"
//     //className="shrink-0 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm"
//      className="w-24 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
//   >
//     Get OTP
//   </button>
// </div>


//         {/* Phone Number */}
//         <div className="flex items-center bg-white rounded-xl px-3 py-2 h-14 font-medium w-full">
//           <Phone className="text-gray-500 mr-2" size={18} />
//           <input
//             type="text"
//             name="mobnum"
//             placeholder="Phone Number"
//             value={data.mobnum}
//             onChange={handleChange}
//             className="w-full bg-transparent outline-none text-gray-800"
//           />
//         </div>

//         {/* OTP Input + Verify Button (Styled Like Email) */}
// <div className="flex bg-white rounded-xl px-3 py-2 items-center space-x-2 w-full h-14">
//   <input
//     type="text"
//     name="code"
//     placeholder="Enter OTP"
//     value={data.code}
//     onChange={handleChange}
//     className="flex-grow bg-transparent outline-none text-gray-800 min-w-0"
//   />
//   <button
//     type="button"
//    // className="shrink-0 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-medium"
//     className="w-32 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700"
//   >
//     Verify
//   </button>
// </div>


//         {/* Company Name */}
//         <div className="flex items-center bg-white rounded-xl px-3 py-2 w-full h-14">
//           <Building className="text-gray-500 mr-2" size={18} />
//           <input
//             type="text"
//             name="compname"
//             placeholder="Company Name"
//             value={data.compname}
//             onChange={handleChange}
//             className="w-full bg-transparent outline-none text-gray-800"
//           />
//         </div>

//         {/* Country */}
//         <div className="flex items-center bg-white rounded-xl px-3 py-2 h-14 w-full">
//           <MapPin className="text-gray-500 mr-2" size={18} />
//           <input
//             type="text"
//             name="country"
//             placeholder="Country"
//             value={data.country}
//             onChange={handleChange}
//             className="w-full bg-transparent outline-none text-gray-800"
//           />
//         </div>

//         {/* Password */}
//         <div className="flex items-center bg-white rounded-xl px-3 py-2 h-14 w-full">
//           <Lock className="text-gray-500 mr-2" size={18} />
//           <input
//             type="password"
//             name="password"
//             placeholder="Password"
//             value={data.password}
//             onChange={handleChange}
//             className="w-full bg-transparent outline-none text-gray-800"
//           />
//         </div>

//         {/* Confirm Password */}
//         <div className="flex items-center bg-white rounded-xl px-3 py-2 h-14 w-full">
//           <Lock className="text-gray-500 mr-2" size={18} />
//           <input
//             type="password"
//             name="confirm_Password"
//             placeholder="Confirm Password"
//             value={data.confirm_Password}
//             onChange={handleChange}
//             className="w-full bg-transparent outline-none text-gray-800"
//           />
//         </div>

//         {/* Address - full width */}
//         <div className="col-span-2 flex items-start bg-white rounded-xl px-3 py-2">
//           <MapPin className="text-gray-500 mr-2 mt-2" size={18} />
//           <textarea
//             name="address"
//             placeholder="Address"
//             value={data.address}
//             onChange={handleChange}
//             className="w-full bg-transparent outline-none resize-none text-gray-800"
//             rows={2}
//           />
//         </div>

//         {/* Sign Up Button */}
//         <div className="col-span-2">
//           <button
//             type="submit"
//            // className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-xl text-lg font-semibold transition"
//            className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-base font-semibold transition mx-auto block"
//           >
//             Sign up
//           </button>
//         </div>
//       </form>
//     </div>
//   </div>
// </div>

//   );
// };

// export default AdminSignin;

import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from "../Config";
import Swal from "sweetalert2";
import logo from "../assets/img/mjlogo.png";
import { Mail, User, Lock, Phone, MapPin, Building } from "lucide-react";

const AdminSignin = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    Username: "",
    mobnum: "",
    address: "",
    email: "",
    compname: "",
    country: "",
    password: "",
    confirmPassword: "",
    // code: "",
  });

   const [otpSent, setOtpSent] = useState(false);
  // const [password, setPassword] = useState('');

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // ✅ Send OTP
  const SendEmail = async () => {
    if (!data.email) {
      Swal.fire("Error", "Please enter your email", "error");
      return;
    }
    const formData = new FormData();
    formData.append("email", data.email);

    try {
      const res = await axios.post(`${API_URL}/api/v2/send-code`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.status === 201) {
        Swal.fire("Success", "OTP sent to your email", "success");
        setOtpSent(true);
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data || "Error sending OTP", "error");
    }
  };

  // ✅ Verify OTP
  const VerifyCode = async () => {
    if (!data.code) {
      Swal.fire("Error", "Please enter the OTP", "error");
      return;
    }

    const formData = new FormData();
    formData.append("email", data.email);
    formData.append("code", data.code);

    try {
      const res = await axios.post(`${API_URL}/api/v2/verify-code`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.status === 200) {
        Swal.fire("Success", res.data.message, "success");
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Invalid OTP", "error");
    }
  };

  // ✅ Submit full registration
  const submitForm = async (e) => {
    e.preventDefault();
    if (data.password !== data.confirm_Password) {
    Swal.fire("Error", "Passwords do not match!", "error");
    return;
  }
    try {
      const response = await axios.post(`${API_URL}/api/v2/AdminRegister`, data);
      if (response.status === 200) {
        Swal.fire("Success", "Registration successful!", "success");
        navigate("/admin");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  console.log(data);
  return (
    <div className="w-screen h-screen flex items-center justify-center bg-gradient-to-b from-black to-blue-950 px-4">
      <div className="flex rounded-2xl overflow-hidden w-full max-w-6xl">
        <div className="w-1/3 flex items-center justify-center bg-transparent">
          <img src={logo} alt="Media Jungle" className="w-80 scale-110 drop-shadow-lg" />
        </div>

        {/* Left: Form Section */}
        <div className="w-2/3 flex flex-col justify-center px-10 py-12">
          {/* Title */}
          <div className="text-center mb-8">
            <h1 className="text-7xl font-bold text-white">Welcome</h1>
            <p className="text-2xl text-gray-300">
              To New <span className="font-bold text-white">Admin</span>
            </p>
          </div>

          {/* Form */}
          <form onSubmit={submitForm} className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
            {/* Username */}
            <div className="flex items-center bg-white rounded-xl px-4 py-3 h-14 w-full">
              <User className="text-gray-500 mr-2" size={18} />
              <input
                type="text"
                name="username"
                placeholder="Username"
                value={data.username}
                onChange={handleChange}
                className="w-full bg-transparent outline-none text-gray-800"
              />
            </div>
        
            {/* Email + Get OTP */}
            <div className="flex bg-white rounded-xl px-3 py-2 items-center space-x-2 h-14 w-full">
              <Mail className="text-gray-500" size={18} />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={data.email}
                onChange={handleChange}
                className="flex-grow bg-transparent outline-none text-gray-800 min-w-0"
              />
              {/* <button
                type="button"
                onClick={SendEmail}
                className="w-24 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
              >
                Get OTP
              </button> */}
            </div>

            {/* Phone Number */}
            <div className="flex items-center bg-white rounded-xl px-3 py-2 h-14 font-medium w-full">
              <Phone className="text-gray-500 mr-2" size={18} />
              <input
                type="text"
                name="mobnum"
                placeholder="Phone Number"
                value={data.mobnum}
                onChange={handleChange}
                className="w-full bg-transparent outline-none text-gray-800"
              />
            </div>

            {/* OTP + Verify */}
            <div className="flex bg-white rounded-xl px-3 py-2 items-center space-x-2 w-full h-14">
              <input
                type="text"
                name="code"
                placeholder="Enter OTP"
                value={data.code}
                onChange={handleChange}
                className="flex-grow bg-transparent outline-none text-gray-800 min-w-0"
              />
              {/* <button
                type="button"
                onClick={VerifyCode}
                className="w-32 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700"
              >
                Verify
              </button> */}
            </div>

            {/* Company Name */}
            <div className="flex items-center bg-white rounded-xl px-3 py-2 w-full h-14">
              <Building className="text-gray-500 mr-2" size={18} />
              <input
                type="text"
                name="compname"
                placeholder="Company Name"
                value={data.compname}
                onChange={handleChange}
                className="w-full bg-transparent outline-none text-gray-800"
              />
            </div>

            {/* Country */}
            <div className="flex items-center bg-white rounded-xl px-3 py-2 h-14 w-full">
              <MapPin className="text-gray-500 mr-2" size={18} />
              <input
                type="text"
                name="country"
                placeholder="Country"
                value={data.country}
                onChange={handleChange}
                className="w-full bg-transparent outline-none text-gray-800"
              />
            </div>

            {/* Password */}
            <div className="flex items-center bg-white rounded-xl px-3 py-2 h-14 w-full">
              <Lock className="text-gray-500 mr-2" size={18} />
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={data.password}
                onChange={handleChange}
                className="w-full bg-transparent outline-none text-gray-800"
              />
            </div>

            {/* Confirm Password */}
            <div className="flex items-center bg-white rounded-xl px-3 py-2 h-14 w-full">
              <Lock className="text-gray-500 mr-2" size={18} />
              <input
                type="password"
                name="confirm_Password"
                placeholder="Confirm Password"
                value={data.confirm_Password}
                onChange={handleChange}
                className="w-full bg-transparent outline-none text-gray-800"
              />
            </div>

            {/* Address - full width */}
            <div className="col-span-2 flex items-start bg-white rounded-xl px-3 py-2">
              <MapPin className="text-gray-500 mr-2 mt-2" size={18} />
              <textarea
                name="address"
                placeholder="Address"
                value={data.address}
                onChange={handleChange}
                className="w-full bg-transparent outline-none resize-none text-gray-800"
                rows={2}
              />
            </div>

            {/* Sign Up Button */}
            <div className="col-span-2">
              <button
                type="submit"
                className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-base font-semibold transition mx-auto block"
              >
                Sign up
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminSignin;